import { create } from 'zustand';

export interface Toast {
  id: string;
  message: string;
  type: 'error' | 'success' | 'info';
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, type?: Toast['type']) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (message, type = 'error') => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, 5000);
  },
  removeToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export function notifyError(error: unknown, fallback = 'Something went wrong. Please try again.') {
  const message = error instanceof Error && error.message ? error.message : fallback;
  useToastStore.getState().addToast(message, 'error');
}

// For something the user should know about that isn't a failure, such as
// someone else deleting the task they had open.
export function notifyInfo(message: string) {
  useToastStore.getState().addToast(message, 'info');
}
